import {makeSignUpCheckExistence} from 'main/factories/usecases';
import {SignUpCheckExistenceParams} from './types.js';

export async function signUpCheckExistence({signal, ...checkParams}: SignUpCheckExistenceParams) {
	const response = await makeSignUpCheckExistence().signUpCheckExistence({
		signal,
		...checkParams,
	});

	return response;
}
